// OCR 부가정보 → notes 합성 (앱 heydealer_ocr.dart `notes` / 웹 OrderFormPanel 메모 빌더와 같은 형식).
// 낙찰가·사고이력·정비·상태는 스칼라 필드가 없어 메모로만 전달된다 — 평가사가 읽는 한국어 본문.
function num(v) {
  var n = Number(v);
  return !n || isNaN(n) ? 0 : n;
}

function money(v) { return num(v).toLocaleString('en-US'); }

export function buildOcrNotes(r) {
  var o = r || {};
  var lines = [];
  if (num(o.purchasePrice) > 0) {
    var head = '낙찰가: ' + money(o.purchasePrice) + '만원';
    if (num(o.newCarPrice) > 0) head += ' (신차 ' + money(o.newCarPrice) + '만원)';
    if (num(o.auctionParticipants) > 0) head += ' / 참여 ' + num(o.auctionParticipants) + '명';
    lines.push(head);
  }
  if (o.accidentHistory || o.exteriorPanel) {
    var acc = '[사고] ' + (o.accidentHistory || '');
    if (o.exteriorPanel) acc += ', 외판 ' + o.exteriorPanel;
    if (o.ownerChange) acc += ', 소유자 ' + o.ownerChange;
    lines.push(acc);
  }
  if (o.repairNeeded) lines.push('[정비] ' + o.repairNeeded);
  if (o.carPros) lines.push('[장점] ' + o.carPros);
  if (o.wheelScratch || o.tireCondition || o.spareKey) {
    var cond = '[상태] ';
    if (o.wheelScratch) cond += '휠기스:' + o.wheelScratch;
    if (o.tireCondition) cond += ' 타이어:' + o.tireCondition;
    if (o.spareKey) cond += ' 보조키:' + o.spareKey;
    lines.push(cond.trim());
  }
  (o.myCarDamage || []).forEach(function (d) {
    if (d) lines.push('[내차피해] ' + (d.date || '') + ' 수리비 ' + (d.repairCost || 0) + '만원');
  });
  (o.otherCarDamage || []).forEach(function (d) {
    if (d) lines.push('[타차가해] ' + (d.date || '') + ' 수리비 ' + (d.repairCost || 0) + '만원');
  });
  return lines.join('\n');
}

export default buildOcrNotes;
